import { useSuspenseQuery } from '@tanstack/react-query';
import { useInstanceId } from 'shared/src/hooks';
import { addressService } from 'mypage/src/api/addressService';
import { queryKey } from '../../../constant/queryKey';

export const useGetAddresses = () => {
  const instanceId = useInstanceId();
  return useSuspenseQuery({
    queryKey: queryKey.addresses(instanceId),
    queryFn: () => addressService.getAddresses(),
  });
};
